module.exports = __webpack_public_path__ + "static/img/white-teacher.6234faa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invitation/white-teacher.png
// module id = rOxp
// module chunks = 2